import i18n from '../language/i18n';

const {t} = i18n.global;
const routes =
    [
        {
            path: '/edit/:id',
            name: 'edit',
            component: () => import(/* webpackChunkName: "/dyn/edit" */ '#/edit/index'),

        },

        {
            path: '/verify/pin/:hash',
            name: 'edit-verify-pin',
            component: () => import(/* webpackChunkName: "/dyn/edit" */ '#/edit/verification-pin'),
        },

        {
            path: '/edit/account/:id',
            name: 'edit-account',
            component: () => import(/* webpackChunkName: "/dyn/edit" */ '#/edit/account'),
        },

        {
            path: '/edit/media/:id',
            name: 'edit-media',
            component: () => import(/* webpackChunkName: "/dyn/edit" */ '#/edit/media'),

        },
        {
            path: '/edit/auto-topup/:id',
            name: 'edit-auto-topup',
            component: () => import(/* webpackChunkName: "/dyn/edit" */ '#/edit/auto-topup'),

        },
        {
            path: '/edit/load/:id',
            name: 'edit-load',
            component: () => import(/* webpackChunkName: "/dyn/edit" */ '#/edit/load-credits'),

        },
        {
            path: '/edit/gallery/:id',
            name: 'media-gallery',
            component: () => import(/* webpackChunkName: "/dyn/edit" */ '#/edit/gallery'),

        },

        {
            path: '/edit/verify/:id',
            name: 'edit-verify',
            component: () => import(/* webpackChunkName: "/dyn/edit" */ '#/edit/verify'),

        },

        {
            path: '/edit/location/:id',
            name: 'location',
            component: () => import(/* webpackChunkName: "/dyn/edit" */ '#/edit/location'),

        },
        {
            path: '/edit/directory/listing/:id',
            name: 'directory',
            component: () => import(/* webpackChunkName: "/dyn/edit" */ '#/edit/directory'),
        },
        {
            path: '/recover/:id/:hash',
            name: 'recover',
            component: () => import(/* webpackChunkName: "/dyn/edit" */ '#/edit/recover'),
        },

    ]
export default routes
